import React, { useState } from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';
import { Chip, Link, Row, Text } from 'library/ui';
import { format12HourTime } from 'shared/Dates';

import { TimeChangeModal } from './TimeChangeModal';

import type { CenterInitiatedAppointmentTimeChangeRequest, WorkerInitiatedAppointmentTimeChangeRequest } from 'models';

const ColorsHashMap = {
    Pending: { background: Colors.lightTerraCotta, foreground: Colors.terraCotta },
    Accepted: { background: Colors.lightGreen, foreground: Colors.turquoise },
    Declined: { background: Colors.errorBackground, foreground: Colors.error },
};

export default function CardRequestedTimeChange({
    type,
    timeChangeRequest,
    refresh,
    timezone,
}: {
    type: 'center' | 'worker';
    timeChangeRequest: CenterInitiatedAppointmentTimeChangeRequest | WorkerInitiatedAppointmentTimeChangeRequest;
    refresh: () => void;
    timezone: string;
}) {
    const colors = ColorsHashMap[`${timeChangeRequest.status}`];

    const action = timeChangeRequest.status === 'Pending' ? 'requested' : timeChangeRequest.status.toLowerCase();

    const someone = {
        center: timeChangeRequest.status === 'Pending' ? 'You' : 'A worker',
        worker: timeChangeRequest.status === 'Pending' ? 'A worker' : 'You',
    }[`${type}`];

    const title = `${someone} ${action} a time change`;

    const [open, setOpen] = useState(false);

    return (
        <Container backgroundColor={colors.background}>
            <Text size="xs">{title}</Text>
            <Row justify="between" align="center">
                <Text size="xs" weight="bold">
                    {`${format12HourTime(new Date(timeChangeRequest.new_start_time), timezone)} - ${format12HourTime(
                        new Date(timeChangeRequest.new_end_time),
                        timezone,
                    )}`}
                </Text>
                <Chip variant="filled" bgColor={colors.foreground} textColor={Colors.white} size="small">
                    {timeChangeRequest.status}
                </Chip>
            </Row>
            {type === 'worker' && timeChangeRequest.status === 'Pending' && (
                <Row justify="end" align="center">
                    <Link onClick={() => setOpen(true)} size="sm">
                        Click to accept or decline
                    </Link>
                    <TimeChangeModal open={open} setOpen={setOpen} request={timeChangeRequest} refresh={refresh} />
                </Row>
            )}
        </Container>
    );
}

const Container = styled('div')(({ backgroundColor }: { backgroundColor: string }) => ({
    backgroundColor,
    borderRadius: 5,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    padding: 5,
    flex: 1,
}));
